module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.4f536b7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-whatsapp.svg
// module id = 1869
// module chunks = 0